
import Grid from "@mui/material/Grid";
import Checkbox from "@mui/material/Checkbox";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import axios from "axios";
import { useForm, Controller } from "react-hook-form";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CircularProgress, Backdrop, TextField } from "@mui/material";
import Config from "../../config.js";
import { Country, State, City } from "country-state-city";
import { useTranslation } from "react-i18next";
import { Select, MenuItem } from "@mui/material";
import MDEditor from "components/MDEditor/index.js";
import { useNavigate } from "react-router-dom";
import { handleErrors, checkPrivilege, processCustomFields } from "common.js";
import { PRIVILEGE, VENDORPYAMENT } from "constants.js";
import RenderCustomField from "layouts/components/RenderCustomField.js";

function EditVendor(props) {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const states = State.getStatesOfCountry("IN");
  const vendorId = useParams().id;
  const BASE = Config.BASE;
  const TOKEN = window.localStorage.getItem("token");
  const [vendorData, setData] = useState({});
  const [vendorPaymentConfig, setVendorPaymentConfig] = useState({});
  const [vendorPickupConfig, setVendorPickupConfig] = useState({});
  const [customFields, setCustomFields] = useState([]);
  const adminType = localStorage.getItem("type");
  const [selectedCustomMultiselect, setSelectedCustomMultiselect] = useState([]);
  const detailedDescription = '<p></p>';
  const shortDescription = '<p></p>';

  const { register, handleSubmit, watch, control, setValue, getValues, setError, formState: { errors }, } = useForm();

  const data = (id) => {
    axios({
      url: BASE + "api/vendor/viewProfile/" + id,
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY,
      },
    })
      .then(function (response) {

        const requestStatus = response.status;
        if (requestStatus == 200) {
          const status = response.data.status;
          const message = response.data.message;
          if (status == 1) {
            setData(response.data);
            setVendorPaymentConfig(response.data.data.paymentConfig);
            setVendorPickupConfig((response.data.data.pickupLocation) ? response.data.data.pickupLocation : {})
            setValueFn(response.data.data.profile);
            setIsLoading(false);
            const responseData = response.data.data;
            if (responseData.customFields.length > 0) {
              setCustomFields(response.data.data.customFields);
              let value = responseData.customFields;
              value.map((item) => {
                if (item.fieldType == 6) {
                  setSelectedCustomMultiselect((selectedCustomMultiselect) => ({
                    ...selectedCustomMultiselect,
                    [item.fieldName]: item.value,
                  }));
                }
              })
            }
          }
          else {
            toast.error(t(message));
            const redirectTimeout = setTimeout(() => {
              clearTimeout(redirectTimeout);
              navigate('/vendor/list')
            }, 3000);
          }
        }
        else {
          toast.error(t('unableToProccessRequest'));
          const redirectTimeout = setTimeout(() => {
            clearTimeout(redirectTimeout);
            navigate('/vendor/list')
          }, 3000);
        }
      })
      .catch(function (error) {
        setIsLoading(false);
        handleErrors(error, t, navigate);
      });
  };

  useEffect(() => {
    data(vendorId);
  }, []);

  const setValueFn = (setValueData) => {
    setValue("id", vendorId);
    setValue("email", setValueData.email);
    setValue("mobileNumber", setValueData.mobileNumber);
    setValue("adminCommissionPercentage", setValueData.adminCommissionPercentage);
    setValue("address", setValueData.address);
    setValue("name", setValueData.name);
    setValue("state", (setValueData.state) ? setValueData.state : 0);
    setValue("city", setValueData.city);
    setValue("shopName", setValueData.shopName);
    setValue("zipCode", setValueData.zipCode);
    setValue('shortDescription', (setValueData.shortDescription) ? setValueData.shortDescription : '<p></p>');
    setValue("detailedDescription", (setValueData.detailedDescription) ? setValueData.detailedDescription : '<p></p>');
    setValue("deliveryDays", setValueData.deliveryDays);
    setValue("returnDays", setValueData.returnDays);
    setValue("refundDays", setValueData.refundDays);
  };

  const onSubmit = async (data) => {
    setIsLoading(true);
    const customFieldData = processCustomFields(
      customFields,
      selectedCustomMultiselect,
      getValues
    );
    data.customFields = customFieldData;
    axios({
      url: BASE + "api/vendor/editProfile",
      method: "POST",
      data: data,
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY,
      },
    })
      .then(function (response) {
        setIsLoading(false);
        if (response.status == 200) {
          const status = response.data.status;
          const message = response.data.message;
          if (status == 1) {
            toast.success(t(message))
            const redirectTimeout = setTimeout(() => {
              clearTimeout(redirectTimeout);
              navigate(`/vendor/list`);
            }, 2000);
          }
          else {
            if (message != '')
              toast.error(t(message))
            if (response && response.data && response.data.errors) {
              const errorData = response.data.errors;
              errorData.forEach((error) => {
                setError(error.field, {
                  type: 'server',
                  message: t(error.errors[0])
                });
              });
            }
          }
        }
        else {
          toast.error(t('unableToProccessRequest'));
        }
      })
      .catch(function (error) {
        setIsLoading(false);
        handleErrors(error, t, navigate);
      });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={t("Edit Vendor")} />
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading} >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            {vendorData ? (
              <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)} >
                <MDBox px={3}>
                  <Grid container spacing={2} mt={3} >
                    <Grid item xs={12} sm={6} md={4}>
                      <label className="font-style">{t("Vendor email")}</label>
                      <span className="inputMandatory">*</span>
                    </Grid>
                    <Grid item xs={12} sm={6} md={8}>
                      <MDInput
                        type="email"
                        name="email"
                        {...register("email", {
                          required: true,
                          pattern: /^[^@ ]+@[^@ ]+\.[^@ .]{2,}$/,
                        })}
                        fullWidth
                      />
                      {errors.email && errors.email.type === "required" && (<p className="errorMsg">{t("Email is required")}</p>)}
                      {errors.email && errors.email.type === "pattern" && (<p className="errorMsg">{t("Email is not valid.")}</p>)}
                      {errors.email && (<p className="errorMsg">{t(errors.email.message)}</p>)}
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                      <label className="font-style">{t("vendor name")}</label>
                      <span className="inputMandatory">*</span>
                    </Grid>
                    <Grid item xs={12} sm={6} md={8}>
                      <MDInput
                        type="text"
                        name="name"
                        {...register("name", {
                          required: true,
                          message: t("Name is mandatory"),
                        })}
                        fullWidth
                      />
                      {errors.name && errors.name.type === "required" && (
                        <p className="errorMsg">{t("Name is mandatory")}</p>
                      )}
                      {errors.name && (
                        <p className="errorMsg">{t(errors.name.message)}</p>
                      )}
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                      <label className="font-style"> {t("Vendor shop name")} </label>
                      <span className="inputMandatory">*</span>
                    </Grid>
                    <Grid item xs={12} sm={6} md={8}>
                      <MDInput
                        type="text"
                        name="shopName"
                        {...register("shopName", {
                          required: {
                            value: true,
                            message: t("Shopname is required"),
                          },
                        })}
                        onChange={((e) => {
                          e.stopPropagation();
                          if ((e.target.value).length != 0) {
                            setValue('shopName', (e.target.value).charAt(0).toUpperCase() + (e.target.value).slice(1));
                          }
                        })}
                        fullWidth
                      />
                      {errors.shopName && (
                        <p className="errorMsg"> {t(errors.shopName.message)} </p>
                      )}
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                      <label className="font-style">{t("vendor address")}</label>
                      <span className="inputMandatory">*</span>
                    </Grid>
                    <Grid item xs={12} sm={6} md={8}>
                      <MDInput
                        multiline
                        rows={5}
                        name="address"
                        label=""
                        {...register("address", { required: true })}
                        fullWidth
                      />
                      {errors.address && errors.address.type === "required" && (<p className="errorMsg">{t("address mandatory")}</p>)}
                      {errors.address && (<p className="errorMsg"> {t(errors.address.message)} </p>)}
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                      <label className="font-style">{t("country")}</label>
                      <span className="inputMandatory">*</span>
                    </Grid>
                    <Grid item xs={12} sm={6} md={8}>
                      <MDInput
                        type="text"
                        name="country"
                        value="India"
                        disabled={true}
                        InputProps={{
                          classes: { root: "inputBoxStyle" },
                        }}
                        fullWidth />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                      <label className="font-style">{t("state")}</label>
                      <span className="inputMandatory">*</span>
                    </Grid>
                    <Grid item xs={12} sm={6} md={8}>
                      <Controller
                        name="state"
                        control={control}
                        rules={{
                          required: {
                            value: true,
                            message: t('stateRequired')
                          },
                          validate: (value) => {
                            if (value === "0") {
                              return t('stateRequired');
                            }
                            return true;
                          },
                        }}
                        defaultValue={0}
                        render={({ field }) => (
                          <TextField
                            select
                            {...field}
                            fullWidth
                            InputProps={{
                              classes: { root: "select-input-styles paddingZero" },
                            }}
                          >
                            <MenuItem key={"select-state"} value="0">{t("--Select--")}</MenuItem>
                            {states.map((state) => (
                              <MenuItem key={state.isoCode} value={state.isoCode}>{state.name}</MenuItem>
                            ))}
                          </TextField>
                        )}
                      />
                      {errors.state && (
                        <span className="errorMsg floatRight">{errors.state.message}</span>
                      )}
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                      <label className="font-style">{t("City")}</label>
                      <span className="inputMandatory">*</span>
                    </Grid>
                    <Grid item xs={12} sm={6} md={8}>
                      <MDInput
                        type="text"
                        name="city"
                        label=""
                        {...register("city", { required: true })}
                        fullWidth
                      />
                      {errors.city && errors.city.type === "required" && (<p className="errorMsg">{t("Please select city")}</p>)}
                      {errors.city && (<p className="errorMsg">{t(errors.city.message)}</p>)}
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                      <label className="font-style">{t("ZIP Code")}</label>
                      <span className="inputMandatory">*</span>
                    </Grid>
                    <Grid item xs={12} sm={6} md={8}>
                      <MDInput
                        type="text"
                        name="zipCode"
                        label=""
                        {...register("zipCode", { required: true })}
                        fullWidth
                      />

                      {errors.zipCode && errors.zipCode.type === "required" && (<p className="errorMsg"> {t("ZIP code is mandatory")}</p>)}
                      {errors.zipCode && (<p className="errorMsg">{t(errors.zipCode.message)}</p>)}
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                      <label className="font-style">{t("Vendor mobile numer")}</label>
                      <span className="inputMandatory">*</span>
                    </Grid>
                    <Grid item xs={12} sm={6} md={8}>
                      <MDInput
                        type="text"
                        name="mobileNumber"
                        label=""
                        {...register("mobileNumber", {
                          required: true,
                          message: t("mobile number mandatory"),
                        })}
                        fullWidth
                      />
                      {errors.mobileNumber && errors.mobileNumber.type === "required" && (<p className="errorMsg"> {t("mobile number mandatory")}</p>)}
                      {errors.mobileNumber && (<p className="errorMsg">{t(errors.mobileNumber.message)}</p>)}
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <label className="font-style">{t("adminCommissionPercentage")}</label>
                    </Grid>
                    <Grid item xs={12} sm={6} md={8}>
                      <MDInput
                        type="text"
                        name="adminCommissionPercentage"
                        label=""
                        {...register("adminCommissionPercentage")}
                        fullWidth
                      />
                      {errors.adminCommissionPercentage && (<p className="errorMsg">{t(errors.adminCommissionPercentage.message)}</p>)}
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <label className="font-style">{t("short description")}</label>
                    </Grid>
                    <Grid item xs={12} sm={6} md={8}>
                      {(vendorData && vendorData.data && vendorData.data.profile) &&
                        <Controller
                          name="shortDescription"
                          control={control}
                          defaultValue={shortDescription}
                          render={({ field }) => (
                            <MDEditor
                              value={field.value}
                              onChange={(updatedContent) => {
                                const data = updatedContent;
                                field.onChange(data);
                              }}
                            />
                          )}
                        />
                      }
                      {errors.shortDescription && (
                        <p className="errorMsg">
                          {t(errors.shortDescription.message)}
                        </p>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <label className="font-style">{t("detailed description")}</label>
                    </Grid>
                    <Grid item xs={12} sm={6} md={8}>
                      {(vendorData && vendorData.data && vendorData.data.profile) &&
                        <Controller
                          name="detailedDescription"
                          control={control}
                          defaultValue={detailedDescription}
                          render={({ field }) => (
                            <MDEditor
                              value={field.value}
                              onChange={(updatedContent) => {
                                const data = updatedContent;
                                field.onChange(data);
                              }}
                            />
                          )}
                        />
                      }
                      {errors.detailedDescription && (<p className="errorMsg">{t(errors.detailedDescription.message)}</p>)}
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <label className="font-style">{t("delivery days")}</label>
                    </Grid>
                    <Grid item xs={12} sm={6} md={8}>
                      <MDInput
                        type="number"
                        InputProps={{ inputProps: { min: 0 } }}
                        name="deliveryDays"
                        label=""
                        {...register("deliveryDays")}
                        fullWidth
                      />
                      {errors.deliveryDays && (<p className="errorMsg">{t(errors.deliveryDays.message)}</p>)}
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <label className="font-style">{t("return days")}</label>
                    </Grid>
                    <Grid item xs={12} sm={6} md={8}>
                      <MDInput
                        type="number"
                        InputProps={{ inputProps: { min: 0 } }}
                        name="returnDays"
                        label=""
                        {...register("returnDays")}
                        fullWidth
                      />
                      {errors.returnDays && (<p className="errorMsg">{t(errors.returnDays.message)}</p>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <label className="font-style">{t("refund days")}</label>
                    </Grid>
                    <Grid item xs={12} sm={6} md={8}>
                      <MDInput
                        type="number"
                        InputProps={{ inputProps: { min: 0 } }}
                        name="refundDays"
                        label=""
                        {...register("refundDays")}
                        fullWidth
                      />
                      {errors.refundDays && (<p className="errorMsg">{t(errors.refundDays.message)}</p>)}
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}><label className="font-style">{t("Vendor password")}</label>
                    </Grid>
                    <Grid item xs={12} sm={6} md={8}>
                      <MDInput
                        type="password"
                        name="password"
                        label=""
                        {...register("password", {
                          minLength: 6,
                        })}
                        fullWidth
                      />
                      {errors.password && (<p className="errorMsg">{t(errors.password.message)}</p>)}
                    </Grid>

                    {customFields.length > 0 ? (
                      <Grid item xs={12}>
                        <Card className="BoxShadowNone">
                          <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} lg={12} sm={12} md={12}>
                              <MDTypography variant="h6" className="uppercaseLetters" >{t("extraInformation")}</MDTypography>
                            </Grid>
                            <Grid item xs={12} lg={12} sm={12} md={12}>
                              {customFields && customFields.map((item) => <RenderCustomField key={item.id}
                                dataFrom={"vendor"}
                                item={item}
                                from="general"
                                selectedCustomMultiselect={selectedCustomMultiselect}
                                errors={errors}
                                register={register}
                                control={control}
                                setValue={setValue}
                                setError={setError}
                                t={t}
                                vendorId={vendorId}
                                setSelectedCustomMultiselect={setSelectedCustomMultiselect}
                                customFields={customFields}
                                setCustomFields={setCustomFields}
                                setIsLoading={setIsLoading}
                              />)}
                            </Grid>
                          </Grid>
                        </Card>
                      </Grid>
                    ) : null}

                    <Grid item xs={12} sm={4} md={4}></Grid>
                    <Grid item xs={12} sm={8} md={8}>
                      {(adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && checkPrivilege("vendor", "write"))) ?
                        <MDButton type="submit" variant="gradient" color="info" className="edit-button-mb" disableRipple>{t("Update")}</MDButton>
                        : null}
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} className="TopBottomPadding-30">
                    <Grid item xs={12} sm={12} md={12}>
                      <MDTypography variant="h6" className="uppercaseLetters" >{t("paymentConfigurationDetails")}</MDTypography>
                    </Grid>
                    {(vendorData && vendorData.data && vendorData.data.profile && vendorData.data.profile.paymentMode == VENDORPYAMENT.BANKPAYMENT) ?
                      <>
                        <Grid item xs={12} sm={6} md={4}>
                          <label className="font-style">
                            {t("Bank name")}
                          </label>
                        </Grid>
                        <Grid item xs={12} sm={6} md={8}>
                          <p className="font-style">
                            {vendorPaymentConfig.bankPayeeName || '-'}
                          </p>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <label className="font-style">
                            {t("Bank account number")}
                          </label>
                        </Grid>
                        <Grid item xs={12} sm={6} md={8}>
                          <p className="font-style">
                            {vendorPaymentConfig.bankAccountNumber || '-'}
                          </p>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <label className="font-style">
                            {t("Bank branch")}
                          </label>
                        </Grid>
                        <Grid item xs={12} sm={6} md={8}>
                          <p className="font-style">
                            {vendorPaymentConfig.bankBranch || '-'}
                          </p>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <label className="font-style">
                            {t("Bank payee name")}
                          </label>
                        </Grid>
                        <Grid item xs={12} sm={6} md={8}>
                          <p className="font-style">
                            {vendorPaymentConfig.bankPayeeName || '-'}
                          </p>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <label className="font-style">
                            {t("Bank IFSC code")}
                          </label>
                        </Grid>
                        <Grid item xs={12} sm={6} md={8}>
                          <p className="font-style">
                            {vendorPaymentConfig.bankIFSC || '-'}
                          </p>
                        </Grid>
                      </>
                      : null}
                    {(vendorData && vendorData.data && vendorData.data.profile && vendorData.data.profile.paymentMode == VENDORPYAMENT.UPIPAYMENT) ?
                      <>
                        <Grid item xs={12} sm={6} md={4}>
                          <label className="font-style">
                            {t("UPI id")}
                          </label>
                        </Grid>
                        <Grid item xs={12} sm={6} md={8}>
                          <p className="font-style">
                            {vendorPaymentConfig.upiId || '-'}
                          </p>
                        </Grid>
                      </>
                      : null
                    }
                  </Grid>
                  <Grid container spacing={2} >
                    <Grid item xs={12} sm={12} md={12}>
                      <MDTypography variant="h6" className="uppercaseLetters" >{t("pickupLocation")}</MDTypography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <label className="font-style">
                        {t("name")}
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={6} md={8}>
                      <p className="font-style">
                        {vendorPickupConfig.name || '-'}
                      </p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <label className="font-style">
                        {t("email")}
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={6} md={8}>
                      <p className="font-style">
                        {vendorPickupConfig.email || '-'}
                      </p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <label className="font-style">
                        {t("Phone")}
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={6} md={8}>
                      <p className="font-style">
                        {vendorPickupConfig.phone || '-'}
                      </p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <label className="font-style">
                        {t("Address")}
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={6} md={8}>
                      <p className="font-style">
                        {vendorPickupConfig.address || '-'}
                      </p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <label className="font-style">
                        {t("City")}
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={6} md={8}>
                      <p className="font-style">
                        {vendorPickupConfig.city || '-'}
                      </p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <label className="font-style">
                        {t("State")}
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={6} md={8}>
                      <p className="font-style">
                        {(vendorPickupConfig.state) ? states.map((state) => ((vendorPickupConfig.state == state.isoCode) ? state.name : null)) : '-'}
                      </p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <label className="font-style">
                        {t("Country")}
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={6} md={8}>
                      <p className="font-style">
                        {vendorPickupConfig.country || '-'}
                      </p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <label className="font-style">
                        {t("PIN")}
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={6} md={8}>
                      <p className="font-style">
                        {vendorPickupConfig.pin || '-'}
                      </p>
                    </Grid>
                  </Grid>
                </MDBox>
              </MDBox>
            ) : null}
          </Card>
        </Grid>
      </Grid>
    </DashboardLayout>
  );
}

export default EditVendor;
